document.addEventListener('DOMContentLoaded', () => {
  const images = document.querySelectorAll('.side-tab-image');
  const contents = document.querySelectorAll('.side-tab-content__inner');
  // Ensure we calculate totalItems based on the lesser count between images and contents, assuming they should be paired.
  const totalItems = Math.min(images.length, contents.length) / 2;
  let currentIndex = 0;
  const titles = document.querySelectorAll('.side-tab-title');
  let slideInterval;

  function updateActiveClass() {
    images.forEach((img, index) => {
      img.classList.toggle('active', index === currentIndex);
    });
    contents.forEach((content, index) => {
      content.classList.toggle('active', index === currentIndex);
    });
  }

  function nextSlide() {
    currentIndex = (currentIndex + 1) % totalItems;
    updateActiveClass();
  }

  function startSlideShow() {
    slideInterval = setInterval(nextSlide, 5000);
  }

  function resetSlideShow() {
    clearInterval(slideInterval);
    startSlideShow();
  }

  startSlideShow(); // Start the slideshow initially

  titles.forEach((title, index) => {
    title.addEventListener('click', () => {
      currentIndex = index % totalItems; // Ensure currentIndex is not out of bounds
      updateActiveClass();
      resetSlideShow(); // Reset the slideshow timer on title click
    });
  });
});
